/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReferredFreelancerRequest
 */
export interface UpdateReferredFreelancerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateReferredFreelancerRequest
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferredFreelancerRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferredFreelancerRequest
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferredFreelancerRequest
     */
    lastname: string;
}

/**
 * Check if a given object implements the UpdateReferredFreelancerRequest interface.
 */
export function instanceOfUpdateReferredFreelancerRequest(value: object): value is UpdateReferredFreelancerRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstname' in value) || value['firstname'] === undefined) return false;
    if (!('lastname' in value) || value['lastname'] === undefined) return false;
    return true;
}

export function UpdateReferredFreelancerRequestFromJSON(json: any): UpdateReferredFreelancerRequest {
    return UpdateReferredFreelancerRequestFromJSONTyped(json, false);
}

export function UpdateReferredFreelancerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferredFreelancerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'email': json['email'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
    };
}

export function UpdateReferredFreelancerRequestToJSON(value?: UpdateReferredFreelancerRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'email': value['email'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
    };
}

